import styled from "styled-components";
import { ContentContainer as HXContentContainer } from "./HXMobilePage.styles";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXMobileButton } from "./HXButton";
export const RevokeConsentRoot = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const ContentContainer = styled(HXContentContainer) `
    gap: 24px;
    padding: 0;
`;
export const RevokeConsentContentView = styled(FlexColumnDiv) `
    gap: 8px;
    flex: 1;
`;
export const RevokeConsentFooteView = styled(FlexColumnDiv) `
    padding: 0;
    gap: 16px;
    align-self: stretch;
    box-sizing: border-box;
`;
export const RevokeConsentActionButton = styled(HXMobileButton) `
    && {
        min-width: 104px;
        border-radius: 28px;
        height: 52px;
        padding: 16px 24px;
    }
`;
export const RevokeConsentButtonRow = styled(FlexRowDiv) `
    align-self: flex-end;
`;
export const RevokeConsentDoneButton = styled(RevokeConsentActionButton) `
    align-self: flex-end;
`;
